<template>
<div>
      <template>
        <v-btn
          @click.stop = "dialog=true"
          color=""
          class="mygreen"
          dark
          >
          <span>有休付与</span></v-btn>
      </template>

    <v-dialog
      v-model="dialog"
      max-width="600px"
    >

      <v-card class="rounded-lg">
        <v-toolbar
          class="mb-9 text-center"
          color="mygreen"
          dark><span class="text-center">有休付与</span></v-toolbar>
        <v-card-text>
          <v-container>
            <v-row>

              <v-col class="text-left" cols="3">スタッフ名</v-col>
              <v-col cols="9" class="text-left">{{staff_name}}</v-col>

              <v-col class="text-left" cols="3">付与日数</v-col>
              <v-col cols="9" >
                  <v-select
                      v-model="days"
                      :items="arr_days"
                      item-text="doctor"
                      item-value="id"
                      outlined
                      placeholder="選択してください"
                  ></v-select>
              </v-col>


              <v-col class="text-left" cols="3">付与種別</v-col>
              <v-col cols="9" >
                <v-text-field outlined
                  v-model="type"
                  hint="手動付与、定期付与(6ヶ月)、定期付与(1.5年)、etc..."
                ></v-text-field>
              </v-col>


              <v-col class="text-left" cols="3">付与理由</v-col>
              <v-col cols="9" >
                      <v-textarea
                          outlined
                          rows="4"
                          v-model="reason"
                          value=""
                        ></v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="pb-6 mt-10">
        <v-row>
            <v-col cols="12" class="text-right mt-10">
              <v-spacer></v-spacer>
              <v-btn
                color="white"
                @click="dialog = false">戻る</v-btn>
              <v-btn dark
                color="mygreen"
                class="ml-6"
                @click="fuyo()">付与</v-btn>
            </v-col>
        </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
</div>
</template>


<script>
// @ is an alias to /src
/* eslint-disable */
import mycolor from '@/mycolor.js';
import axios from 'axios';
/* eslint-disable */



export default {

    props: {
      dialogFlag: Boolean,
      staff_id: String,
      staff_name: String,
    },

    created() {
        console.log('%ccreated: DialogYuukyuuFuyo.vue', mycolor.purple);
    },
    computed:{
        arr_days() {
              const arr_days = []
              for (let i=1; i<=31; i++) {
                arr_days.push(i)
              }
              return arr_days
        }
    },
    // datas
    data() {
            return {

                dialog: false,

                reason: '',
                type: '',
                days: 1,
            }
    },
    methods: {
/* eslint-disable */
        fuyo(){
            console.log('fuyo()');

            let data = {
                staff_id: this.staff_id,
                reason: this.reason,
                type: this.type,
                days: this.days,
                label: '付与',
            };
            console.log('data', data);
            this.dialog = false;


            axios.post('/insert_yuukyuu', data)
              .then((res) => {
                    console.group();
                    console.log('%c %s', mycolor.api, '/insert_yuukyuu');
                    console.log('res: ', res.data);
                    console.groupEnd();
                    location.reload();
              })
              .catch((error) => {
                // eslint-disable-next-line
                console.error(error);
              });


        }  // fuyo()

/* eslint-disable */
    }, // methods
}
</script>

<style scoped>
/deep/ .v-input__append-inner{
    margin: auto !important;
}
/deep/ .row > div {
    height: 70px;
}
/deep/ .v-list-item__content{
    text-align: left;
}
/deep/ .theme--light.v-input{
    margin-top: -8px;
}
/deep/ .v-select__slot{
    height: 40px;
}
/deep/ .v-dialog > .v-card > .v-card__text{
    padding-bottom: 0px;
}
</style>
